__turbopack_context__.v({
  "flatConfigureBtns": "FlatConfigure-module-scss-module__tWuIPa__flatConfigureBtns",
  "flatConfigureBtns__active": "FlatConfigure-module-scss-module__tWuIPa__flatConfigureBtns__active",
  "flatConfigureBtns__active__white": "FlatConfigure-module-scss-module__tWuIPa__flatConfigureBtns__active__white",
  "flatConfigureBtns__btn": "FlatConfigure-module-scss-module__tWuIPa__flatConfigureBtns__btn",
  "flatConfigureBtns__btn__white": "FlatConfigure-module-scss-module__tWuIPa__flatConfigureBtns__btn__white",
  "planText": "FlatConfigure-module-scss-module__tWuIPa__planText",
  "text": "FlatConfigure-module-scss-module__tWuIPa__text",
});
